import type { ReactNode } from 'react'
import { usePresenceStatus } from '../hooks/usePresenceStatus'
import { presenceDotClass } from '../utils/presence'

/**
 * The `.profile` avatar wrapper that draws the user's status dot. A chat row
 * renders it so that only this wrapper re-renders when that user's status
 * changes, not the whole list; the avatar inside is left alone. No `userId`
 * (groups, announcements) means no dot.
 */
const PresenceProfile = ({ userId, children }: { userId?: number | string | null; children: ReactNode }) => {
  const presence = usePresenceStatus(userId)
  return <div className={`profile ${presenceDotClass(presence)}`}>{children}</div>
}

export default PresenceProfile
